import Header from '../common/Header/Header';
import Banner from '../common/Banner/Banner';
import BookDemo from '../common/BookDemo/BookDemo';
import OurCustomers from '../common/OurCustomers/OurCustomers';
import Assessment from '../common/Assessment/Assessment';
import 'assets/scss/modules/landing.scss';
import InterviewHub from '../common/InterviewHub/InterviewHub';
import Footer from '../common/Footer/Footer';
import SuccessPath from '../common/SuccessPath/SuccessPath';
import Empower from '../common/InterviewHub/Empower/Empower';
import WhyBookDemo from '../common/Blogs/WhyBookDemo/WhyBookDemo';
import { useEffect } from 'react';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';

function WelcomeStudent() {
  const { setSettingsPanelConfig } = useSettingsPanelContext();

  useEffect(() => {
    setSettingsPanelConfig({ showSettingPanelButton: false });
  }, []);
  return (
    <main>
      <Header role="student" />
      <Banner role="student" />
      <BookDemo role="student" />
      <OurCustomers />
      <Assessment />
      <SuccessPath role="student" />
      <InterviewHub role="student" />
      <Empower role="student" />
      <WhyBookDemo role="student" />
      <Footer />
    </main>
  );
}

export default WelcomeStudent;
